import axios, {AxiosResponse} from 'axios'
import {ISelect} from '../../../../coreGlobal/models/default'
import {Response} from '../../../../_metronic/helpers'
import {TitemRequest} from './model/sale'

const API_URL = process.env.REACT_APP_API_URL + '/api'
const SALE_URL = `${API_URL}/sales`
const USERS_URL = `${API_URL}/users`
const CREDIT_CARD_REFUNDS_URL = `${API_URL}/credit-card-refunds`
const BILLING_URL = `${API_URL}/billings`

const retryCieloRefund = (refundId: string | number) => {
  return axios.post(`${CREDIT_CARD_REFUNDS_URL}/${refundId}/retry`)
}

const manualSettleCieloRefund = (refundId: string | number) => {
  return axios.post(`${CREDIT_CARD_REFUNDS_URL}/${refundId}/manual-settle`)
}

const sendLinkChargeToCustomer = (saleId: string | number) => {
  return axios.post(`${SALE_URL}/${saleId}/send`)
}

const generateSalePaymentLink = (saleId: string | number): Promise<string> => {
  return axios
    .post(`${SALE_URL}/${saleId}/payment-link`)
    .then((response: any) => response.data.data)
}

const generateBillingPaymentLink = (billingId: string | number): Promise<string> => {
  return axios
    .post(`${BILLING_URL}/${billingId}/payment-link`)
    .then((response: any) => response.data.data)
}

const resendContractToClient = (saleId: string | number, signerType: string) => {
  return axios.post(`${SALE_URL}/${saleId}/send-contract`, {
    signer_type: signerType,
  })
}

const updateSaleReviewAction = (
  saleId: string | number,
  saleReviewAction: boolean,
  observation: string
) => {
  if (saleReviewAction) {
    return axios.post(`${SALE_URL}/${saleId}/approve-review`, {observation})
  } else {
    return axios.post(`${SALE_URL}/${saleId}/reject-review`, {observation})
  }
}
const updatePaymentInstallmentStatus = (
  billingId: string | number,
  installmentId: string | number,
  status: any
) => {
  return axios
    .put(`${BILLING_URL}/${billingId}/installments/${installmentId}/status`, status)
    .then((response: any) => response.data)
    .then((response: any) => response.data)
}

const changeInstallmentPaymentMethod = (
  billingId: string | number,
  installmentId: string | number,
  data: {method: number; installments: number}
) => {
  return axios
    .put(`${BILLING_URL}/${billingId}/installments/${installmentId}/change-payment`, data)
    .then((response: any) => response.data)
}

const updatePayment = (saleId: string | number, data: any) => {
  return axios
    .put(`${SALE_URL}/${saleId}/billings/update-payment-methods`, data)
    .then((response: any) => response.data)
    .then((response: any) => response.data)
}

const getUsers = (): Promise<ISelect[] | undefined> => {
  return axios
    .get(`${USERS_URL}/all`)
    .then((response: AxiosResponse<Response<ISelect[]>>) => response.data)
    .then((response: Response<ISelect[]>) => response.data)
}

const editUser = async (data: TitemRequest, saleId: number) => {
  return await axios
    .post(`${SALE_URL}/${saleId}/change-seller`, data)
    .then((response: any) => response.data)
    .then((response: any) => response.data)
}
export {
  sendLinkChargeToCustomer,
  generateSalePaymentLink,
  generateBillingPaymentLink,
  resendContractToClient,
  updatePayment,
  updatePaymentInstallmentStatus,
  changeInstallmentPaymentMethod,
  getUsers,
  editUser,
  updateSaleReviewAction,
  retryCieloRefund,
  manualSettleCieloRefund,
}
